import { Enviroment } from "../../../enviroments";
import CookieService from "../../autenticacao/CookieService";
import { Api } from "../axios-config"


export interface IDetalheRelatorioPagamentoPendente {

    codigo_Usuario: number;
    nome_Usuario: string;
    email_Usuario: string;
    telefone_Usuario: string;
    quantidade_Liga: number;
    descricao_Liga: string;
    descricao_Temporada: string;
    codEstado: number;

}


export interface IRetornoRelatorioPagamentoPendente {
    dado: IDetalheRelatorioPagamentoPendente[];
    numeroPagina: number;
    tamanhoPagina: number;
    totalPaginas: number;
    totalRegistros: number;
    statusHTTP: number;
    status: number;
}

export interface IDetalheRelatorioLigasUsuario {

    codigo: number;
    nome: string;
    email: string;
    telefone: string;
    pais: string;
    cidade: string;
    estado: string;
    Time_Torcida: number;
    franquia_Torcida: string;
    quantidade_Ligas: number;
    codigo_Estado: number;
    codigo_Cidade: number;
    codigo_Pais: string;
}


export interface IRetornoRelatorioLigasUsuario {
    dado: IDetalheRelatorioLigasUsuario[];
    numeroPagina: number;
    tamanhoPagina: number;
    totalPaginas: number;
    totalRegistros: number;
    statusHTTP: number;
    status: number;
}

export interface IDetalheRelatorioLigasUsuario {

    codigo: number;
    nome: string;
    email: string;
    telefone: string;
    pais: string;
    cidade: string;
    estado: string;
    Time_Torcida: number;
    franquia_Torcida: string;
    quantidade_Ligas: number;
    codigo_Estado: number;
    codigo_Cidade: number;
    codigo_Pais: string;
}


export interface IRetornoRelatorioHistoricoFinanceiroUsuario {
    dado: IHistoricoFinanceiroUsuario[];
    numeroPagina: number;
    tamanhoPagina: number;
    totalPaginas: number;
    totalRegistros: number;
    statusHTTP: number;
    status: number;
}

export interface IHistoricoFinanceiroUsuario {
    codigo: number;
    nome: string;
    caminho_Foto: string;
    nome_Foto: string;
    nome_Foto_Real: string;
    email: string;
    telefone: string;
    data_Cadastro: string;
    valor_Total_Pago: string;
}

export interface IRetornoRelatorioDetalhesHistoricoFinanceiroUsuario {
    dado: IDetalheHistoricoFinanceiroUsuario[];
    numeroPagina: number;
    tamanhoPagina: number;
    totalPaginas: number;
    totalRegistros: number;
    statusHTTP: number;
    codigo_Status: number;
    status: string;
}

export interface IDetalheHistoricoFinanceiroUsuario {
    codigo_Usuario: number;
    codigo_Financeiro: number;
    codigo_Temporada: number;
    descricao_Temporada: number;
    codigo_Liga: number;
    descricao_Liga: number;
    valor: string;
    desconto: string;
    status: string;
}

export interface IRetornoRelatorioReceitasPorTemporada {
    dado: IDetalheRelatorioReceitasPorTemporada[];
    numeroPagina: number;
    tamanhoPagina: number;
    totalPaginas: number;
    totalRegistros: number;
    statusHTTP: number;
    status: number;
}

export interface IDetalheRelatorioReceitasPorTemporada {
    codigo_Temporada: number;
    descricao_Temporada: string;
    valor_Previsto: number;
    quantidade_Prevista: number;
    valor_Recebido: number;
    quantidade_Recebida: number;
    percentual_Recebido: number;
}


const getRelPagamentoPendente = async (codigoTemporada: number = 0, codigoLiga: number = 0): Promise<IRetornoRelatorioPagamentoPendente> => {

    const token = CookieService.get("access_token");
    const { data, headers } = await Api.get(`/relatorio/financeiro/pagamento/pendente`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        },
        params: {
            codigo_Temporada: codigoTemporada > 0 ? codigoTemporada : null,
            NumeroPagina: 1,
            TamanhoPagina: Enviroment.LIMITE_DE_LINHAS,
            Filtro: null,
            Filtro2: null,
            codigoLiga: codigoLiga > 0 ? codigoLiga : null
        }
    });
    return data;
}

const getById = async (codigo: number): Promise<IDetalheRelatorioPagamentoPendente> => {

    const token = CookieService.get("access_token");
    const { data } = await Api.get<IDetalheRelatorioPagamentoPendente>(`/relatorio/pagamento/pendnete/${codigo}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    }
    );

    return data;

}

const getRelLigaUsuario = async (codigoLiga: number = 0, codigoUsuario: number = 0): Promise<IRetornoRelatorioLigasUsuario> => {

    const token = CookieService.get("access_token");
    const { data, headers } = await Api.get(`/relatorio/usuario/ligas/quantidade`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        },
        params: {
            codigo_Liga: codigoLiga ?? null,
            codigo_Usuario: codigoUsuario ?? null,
            NumeroPagina: 1,
            TamanhoPagina: Enviroment.LIMITE_DE_LINHAS,
            Filtro: null,
            Filtro2: null,
            codigoLiga: codigoLiga > 0 ? codigoLiga : null
        }
    });
    return data;
}

const getRelFinanceiroUsuario = async ( codigoUsuario: number = 0): Promise<IRetornoRelatorioHistoricoFinanceiroUsuario> => {

    const token = CookieService.get("access_token");
    const { data, headers } = await Api.get(`/relatorio/financeiro/usuario/historico`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        },
        params: {            
            codigo_Usuario: codigoUsuario ?? null,
            NumeroPagina: 1,
            TamanhoPagina: Enviroment.LIMITE_DE_LINHAS,
            Filtro: null,
            Filtro2: null            
        }
    });
    return data;
}

const getRelDetalhesFinanceiroUsuario = async ( codigoUsuario: number = 0): Promise<IRetornoRelatorioDetalhesHistoricoFinanceiroUsuario> => {

    const token = CookieService.get("access_token");
    const { data, headers } = await Api.get(`/relatorio/financeiro/usuario/historico/detalhes`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        },
        params: {            
            codigo_Usuario: codigoUsuario ?? null,
            NumeroPagina: 1,
            TamanhoPagina: Enviroment.LIMITE_DE_LINHAS,
            Filtro: null,
            Filtro2: null            
        }
    });
    return data;
}

const getRelReceitaPorTemporada = async (codigoLiga: number = 0, codigoTemporada: number = 0): Promise<IRetornoRelatorioReceitasPorTemporada> => {

    const token = CookieService.get("access_token");
    const { data, headers } = await Api.get(`/relatorio/financeiro/receita/temporada`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        },
        params: {
            codigo_Liga: codigoLiga ?? null,
            codigo_Temporada: codigoTemporada ?? null,
            NumeroPagina: 1,
            TamanhoPagina: Enviroment.LIMITE_DE_LINHAS,
            Filtro: null,
            Filtro2: null
        }
    });
    return data;
}


export const RelatorioService = {

    getRelPagamentoPendente,
    getRelLigaUsuario,
    getRelFinanceiroUsuario,
    getRelDetalhesFinanceiroUsuario,
    getById,
    getRelReceitaPorTemporada,
}